var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sku-form',{attrs:{"productId":_vm.productId,"skuId":_vm.skuId}})}
var staticRenderFns = []

export { render, staticRenderFns }